// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove Tailwind directives and use your own CSS */
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background: #fff;
  color: #222;
}

/* Add your custom styles here */
.header {
  position: sticky;
  top: 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  z-index: 50;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}
.logo img {
  height: 48px;
}
.menu {
  display: flex;
  gap: 2rem;
}
.header,
.header .menu-link {
  font-family: 'Montserrat', Arial, sans-serif;
}
.menu-link {
  background: none;
  border: none;
  outline: none;
  color: #555;
  font-family: 'Montserrat', Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 1px;
  position: relative;
  padding: 0 0.5em 0.2em 0.5em;
  margin: 0 1.2vw;
  cursor: pointer;
  transition: color 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.menu-link .menu-underline {
  display: block;
  height: 3px;
  width: 0;
  background: #4f7cff;
  border-radius: 2px;
  margin-top: 6px;
  transition: width 0.35s cubic-bezier(.4,0,.2,1);
}

.menu-link.selected,
.menu-link:hover {
  color: #4f7cff;
}

.menu-link.selected .menu-underline,
.menu-link:hover .menu-underline {
  width: 80%;
}

.menu-link:not(.selected) .menu-underline {
  width: 0;
}

/* Responsive styles for menu, header, etc. remain as before */
.menu-toggle {
  display: none;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
}
.menu-toggle .bar {
  width: 24px;
  height: 3px;
  background: #222;
  border-radius: 2px;
}
@media (max-width: 768px) {
  .menu {
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    background: #fff;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    display: none;
  }
  .menu.open {
    display: flex;
  }
  .menu-toggle {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Remove Tailwind directives and use your own CSS */\nbody {\n  margin: 0;\n  font-family: Arial, sans-serif;\n  background: #fff;\n  color: #222;\n}\n\n/* Add your custom styles here */\n.header {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  z-index: 50;\n}\n.header-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.logo img {\n  height: 48px;\n}\n.menu {\n  display: flex;\n  gap: 2rem;\n}\n.header,\n.header .menu-link {\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n.menu-link {\n  background: none;\n  border: none;\n  outline: none;\n  color: #555;\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-size: 1.2rem;\n  font-weight: 600;\n  letter-spacing: 1px;\n  position: relative;\n  padding: 0 0.5em 0.2em 0.5em;\n  margin: 0 1.2vw;\n  cursor: pointer;\n  transition: color 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.menu-link .menu-underline {\n  display: block;\n  height: 3px;\n  width: 0;\n  background: #4f7cff;\n  border-radius: 2px;\n  margin-top: 6px;\n  transition: width 0.35s cubic-bezier(.4,0,.2,1);\n}\n\n.menu-link.selected,\n.menu-link:hover {\n  color: #4f7cff;\n}\n\n.menu-link.selected .menu-underline,\n.menu-link:hover .menu-underline {\n  width: 80%;\n}\n\n.menu-link:not(.selected) .menu-underline {\n  width: 0;\n}\n\n/* Responsive styles for menu, header, etc. remain as before */\n.menu-toggle {\n  display: none;\n  flex-direction: column;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.menu-toggle .bar {\n  width: 24px;\n  height: 3px;\n  background: #222;\n  border-radius: 2px;\n}\n@media (max-width: 768px) {\n  .menu {\n    position: absolute;\n    top: 64px;\n    left: 0;\n    right: 0;\n    background: #fff;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n    display: none;\n  }\n  .menu.open {\n    display: flex;\n  }\n  .menu-toggle {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
